import {Component, Input} from '@angular/core';
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";

@Component({
  selector: 'app-delivery-point-item',
  templateUrl: './delivery-point-item.component.html',
  styleUrls: ['./delivery-point-item.component.scss']
})
export class DeliveryPointItemComponent {
  @Input() deliveryPoint?: DeliveryPoint
  @Input() blocked = false;
}
